import Vue from 'vue'
import Router from 'vue-router'
import Login from '../pages/Login.vue'
import Scan from '../pages/Scan.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      // Optional :symbol opens the stock details over the screener (the Scan
      // component stays mounted, so filters/results survive back navigation).
      path: '/screener/:symbol?',
      name: 'Scan',
      component: Scan,
      // meta: { requiresAuth: true }
    },

    {
      path: '*',
      redirect: '/screener'
    }
  ]
})
router.beforeEach((to, from, next) => {
  next() // Authentication check hat gaya
})


// router.beforeEach((to, from, next) => {
//   const loggedIn = localStorage.getItem('token')
//   if (to.matched.some(record => record.meta.requiresAuth) && !loggedIn) {
//     next('/login')
//     // next('/screener')
//   } else {
//     next()
//   }
// })

export default router